import { Routes } from "@angular/router";
import { ExternalMAMPanelComponent } from "./external-mam-panel/external-mam-panel.component";
import { ExternalMAMProvidersLayoutComponent } from "./external-mam-providers-layout/external-mam-providers-layout.component";
import { ExternalMAMProvidersSetupLayoutComponent } from "./external-mam-providers-setup/external-mam-providers-setup-layout.component";
import { ExternalMAMGatewayPlaygroundComponent } from "./external-mam-gateway-playground/external-mam-gateway-playground.component";

export const ExternalMAMRoutes: Routes = [
  {
    path: "external-mam",
    component: ExternalMAMPanelComponent,
    canActivate: [],
    children: [
      {
        path: "setup/:name",
        component: ExternalMAMProvidersSetupLayoutComponent,
      },
      {
        path: "edit/:name/:id",
        component: ExternalMAMProvidersSetupLayoutComponent,
      },
      { path: "search/:id", component: ExternalMAMGatewayPlaygroundComponent },
      { path: "**", component: ExternalMAMProvidersLayoutComponent },
    ],
  },
];
